// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"477":"0a541dbf","573":"0f50b56d","787":"c3525396"}[chunkId] + ".chunk.js";
};